import React, { useState } from 'react';
import ChevronDownSmallDarkMode from '../../Assets/ChevronDownSmallDarkMode.svg';
import ChevronDownLargeDarkMode from '../../Assets/ChevronDownLargeDarkMode.svg';
import Success from '../../Assets/success.gif';
import { isLink, isValidPhoneNumber, verifyEmail } from '../../lib/utils/utils';
import { applySeller } from '../../lib/utils/apiCalls';
import { showToast } from '../../Components/Toaster/Toaster';

const categories = [
    'Clothing',
    'Beauty and Personal Care',
    'Footwares',
    'Kids Wear',
    'Handbags and Accessories',
    'Jewelry and watches',
    'Sustainable Fashion',
];

function ApplySeller() {
    const [success, setSuccess] = useState(false);

    const [gstToggle, setGstToggle] = useState(false);
    const [categoryToggle, setCategoryToggle] = useState(false);

    const defaultFormErrors = {
        brandName: '',
        contactPerson: '',
        phoneNumber: '',
        email: '',
        category: '',
        websiteLink: '',
        isGstAvailable: '',
        socialLink: '',
        brandDescription: '',
    }

    const defaultFormFields = {
        brandName: '',
        contactPerson: '',
        callCode: '91',
        phoneNumber: '',
        email: '',
        category: [],
        websiteLink: '',
        isGstAvailable: null,
        socialLink: '',
        brandDescription: '',
    }

    const [formInputs, setFormInputs] = useState(defaultFormFields);

    const [formErrors, setFormErrors] = useState(defaultFormErrors);

    const changeHandler = (e) => {
        const { name, value } = e.target;
        setFormInputs({...formInputs, [name]: value});
    }

    const handleGstToggle = (e) => {
        e.preventDefault();
        setGstToggle(!gstToggle);
    }

    const handleCategoryToggle = (e) => {
        e.preventDefault();
        setCategoryToggle(!categoryToggle);
    }

    const handleGstOptionClick = (e) => {
        e.preventDefault();
        const value = e.target.id === 'Yes' ? true : false;
        setFormInputs({
            ...formInputs,
            isGstAvailable: value,
        });
        setGstToggle(!gstToggle);
    }

    const handleCategory = (e) => {
        const { id, value } = e.target;

        if(id === 'select-all') {
            if(formInputs.category.length === categories.length) {
                setFormInputs({
                    ...formInputs,
                    category: []
                });
            }
            else {
                setFormInputs({
                    ...formInputs,
                    category: [ ...categories ]
                });
            }
        }
        else {
            if(formInputs.category.includes(value)) {
                let filteredList = formInputs.category.filter(item => item !== value);
                setFormInputs({
                    ...formInputs,
                    category: filteredList
                });
            }
            else {
                setFormInputs({
                    ...formInputs,
                    category: [ ...formInputs.category, value ]
                });
            }
        }
    }

    const handleSelectedCategoryClick = (e) => {
        const { id } = e.target;

        let filteredList = formInputs.category.filter(item => item !== id);
        setFormInputs({
            ...formInputs,
            category: filteredList
        });
    }

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = {};

        if(!formInputs.brandName.trim()) {
            validationErrors.brandName = 'Brand name is required';
        }

        if(!formInputs.contactPerson.trim()) {
            validationErrors.contactPerson = 'Contact person name is required';
        }

        if(!formInputs.phoneNumber.trim()) {
            validationErrors.phoneNumber = 'Phone number is required';
        }
        else if(!isValidPhoneNumber(formInputs.phoneNumber.trim())) {
            validationErrors.phoneNumber = 'Please enter a valid phone number';
        }

        if(!formInputs.email.trim()) {
            validationErrors.email = 'Email is required';
        }
        else if(!verifyEmail(formInputs.email.trim())) {
            validationErrors.email = 'Please enter a valid email address';
        }

        if(formInputs.category.length === 0) {
            validationErrors.category = 'Category is required';
        }

        if(formInputs.websiteLink.trim()) {
            if(!isLink(formInputs.websiteLink.trim())) {
                validationErrors.websiteLink = 'Please enter a valid website link';
            }
        }

        if(formInputs.isGstAvailable === null) {
            validationErrors.isGstAvailable = 'Required field';
        }

        if(!formInputs.socialLink.trim()) {
            validationErrors.socialLink = 'Social media link is required';
        }
        else if(!isLink(formInputs.socialLink.trim())) {
            validationErrors.socialLink = 'Please enter a valid website link';
        }

        if(!formInputs.brandDescription.trim()) {
            validationErrors.brandDescription = 'Brand Description is required';
        }

        if(Object.keys(validationErrors).length === 0) {
            setFormErrors(defaultFormErrors);

            const callData = {
                brandName: formInputs.brandName,
                contactPerson: formInputs.contactPerson,
                phoneNumber: formInputs.phoneNumber,
                email: formInputs.email,
                category: formInputs.category,
                haveGSTRegistered: formInputs.isGstAvailable,
                socialLink: formInputs.socialLink,
                details: formInputs.brandDescription,
            }

            if(formInputs.websiteLink.trim()) {
                callData.websiteLink = formInputs.websiteLink
            }

            const response = await applySeller(callData);
            // eslint-disable-next-line eqeqeq
            if(response.statusCode == '10001') {
                showToast(response.message, 'error');
            }
            // eslint-disable-next-line eqeqeq
            else if(response.statusCode == '10000') {
                setSuccess(true);
            }
        }
        else {
            setFormErrors(validationErrors);
            return;
        }
    }

    return (
        <>
            {
                !success ? 
                <div className='max-w-screen h-screen flex justify-center pb-16 overflow-y-scroll'>
                    <div className="mt-[122px] w-3/4 h-fit px-6 py-[23px] bg-[#121212] rounded-[20px] flex flex-col items-center gap-[25px]">
                        <div className="flex flex-col items-center gap-2">
                            <h1 className='font-semibold text-2xl text-[#FFFFFF] select-none'>Become a Seller on Xenie</h1>

                            <p className='font-normal text-base text-[#B0B0B0] select-none'>Join India's leading socio-commerce platform and showcase your brand to a wider audience!</p>
                        </div>

                        <form className="w-full flex flex-col gap-3">
                            <div className="grid grid-cols-2 gap-x-3 gap-y-3">
                                <div className="flex flex-col gap-1">
                                    <input 
                                        className='placeholder:text-[#B0B0B0] text-[14px] leading-[26px] outline-none py-3 px-[11px] w-full h-fit bg-[#232327] rounded-[9px] border border-[#1F1F1F] text-[#FFFFFF]'
                                        type="text" 
                                        placeholder='Brand Name' 
                                        name='brandName' 
                                        id='brandName' 
                                        value={formInputs.brandName} 
                                        onChange={changeHandler} 
                                    />

                                    {formErrors.brandName && <p className='ml-1 text-[12px] leading-5 text-[#DC2626]'>{formErrors.brandName}</p>}
                                </div>

                                <div className="flex flex-col gap-1">
                                    <input 
                                        className='placeholder:text-[#B0B0B0] text-[14px] leading-[26px] outline-none py-3 px-[11px] w-full h-fit bg-[#232327] rounded-[9px] border border-[#1F1F1F] text-[#FFFFFF]'
                                        type="text" 
                                        placeholder='Contact Person' 
                                        name='contactPerson' 
                                        id='contactPerson' 
                                        value={formInputs.contactPerson} 
                                        onChange={changeHandler} 
                                    />

                                    {formErrors.contactPerson && <p className='ml-1 text-[12px] leading-5 text-[#DC2626]'>{formErrors.contactPerson}</p>}
                                </div>

                                <div className="flex flex-col gap-1">
                                    <div className="py-3 px-[11px] bg-[#232327] rounded-[9px] flex items-center gap-[10px]">
                                        <button onClick={(e) => {e.preventDefault()}} className="outline-none flex items-center w-14 justify-end">
                                            <p className='text-[#B0B0B0] font-normal text-[14px] leadng-[26px]'>+{formInputs.callCode}</p>

                                            <div className="w-6 h-6 flex items-center justify-center">
                                                <img src={ChevronDownSmallDarkMode} alt="" />
                                            </div>
                                        </button>

                                        <input 
                                            className='placeholder:text-[#B0B0B0] text-[14px] leading-[26px] w-[calc(100%-56px)] bg-transparent outline-none text-[#FFFFFF]'
                                            type="number" 
                                            placeholder='enter phone number' 
                                            name='phoneNumber' 
                                            id='phoneNumber' 
                                            value={formInputs.phoneNumber} 
                                            onChange={changeHandler} 
                                        />
                                    </div>

                                    {formErrors.phoneNumber && <p className='ml-1 text-[12px] leading-5 text-[#DC2626]'>{formErrors.phoneNumber}</p>}
                                </div>

                                <div className="flex flex-col gap-1">
                                    <input 
                                        className='placeholder:text-[#B0B0B0] text-[14px] leading-[26px] outline-none py-3 px-[11px] w-full h-fit bg-[#232327] rounded-[9px] border border-[#1F1F1F] text-[#FFFFFF]'
                                        type="email" 
                                        placeholder='Email Address' 
                                        name='email' 
                                        id='email' 
                                        value={formInputs.email} 
                                        onChange={changeHandler} 
                                    />

                                    {formErrors.email && <p className='ml-1 text-[12px] leading-5 text-[#DC2626]'>{formErrors.email}</p>}
                                </div>

                                <div className="flex flex-col gap-1">
                                    <div className="relative text-[14px] leading-[26px] py-3 px-[11px] bg-[#232327] rounded-[9px] flex items-center gap-[10px]">
                                        {
                                            formInputs.category.length > 0 ?
                                            <div className='w-[calc(100%-24px)] flex gap-1 overflow-x-scroll no-scrollbar'>
                                                {formInputs.category.map(category => {
                                                    return (
                                                        <div key={category} id={category} onClick={handleSelectedCategoryClick} className="cursor-pointer px-[6px] py-[3px] rounded text-[12px] leading-5 text-[#B0B0B0] bg-[#35353C] text-nowrap">
                                                            {category} 
                                                        </div>
                                                    )
                                                })}
                                            </div> : 
                                            <p className='w-[calc(100%-24px)] text-[#B0B0B0]'>Category</p>
                                        }

                                        <div onClick={handleCategoryToggle} className="cursor-pointer select-none w-6 h-6 flex items-center justify-center">
                                            <img src={ChevronDownLargeDarkMode} alt="" />
                                        </div>

                                        {
                                            categoryToggle && 
                                            <div className="z-10 absolute w-full h-[200px] overflow-y-scroll top-14 text-[#B0B0B0] left-0 rounded-[9px] bg-[#232327] shadow-[0px_0px_6px_0px_#FFFFFF1F]">
                                                <label className='flex items-center gap-2 w-full select-none cursor-pointer py-3 px-[11px] text-[14px] leading-[26px] text-[#B0B0B0] hover:bg-[#29292E]' htmlFor="select-all">
                                                    <input 
                                                        type="checkbox" 
                                                        id='select-all' 
                                                        name='select-all' 
                                                        value='select-all' 
                                                        checked={formInputs.category.length === categories.length} 
                                                        onChange={handleCategory} 
                                                    />
                                                    Select All
                                                </label>

                                                {
                                                    categories.map(category => {
                                                        return (
                                                            <label key={category} className='flex items-center gap-2 w-full select-none cursor-pointer py-3 px-[11px] text-[14px] leading-[26px] text-[#B0B0B0] hover:bg-[#29292E]' htmlFor={category}>
                                                                <input 
                                                                    type="checkbox" 
                                                                    id={category} 
                                                                    name={category} 
                                                                    value={category} 
                                                                    checked={formInputs.category.includes(category)} 
                                                                    onChange={handleCategory}
                                                                />
                                                                {category}
                                                            </label>
                                                        );
                                                    })
                                                }
                                            </div>
                                        }
                                    </div>

                                    {formErrors.category && <p className='ml-1 text-[12px] leading-5 text-[#DC2626]'>{formErrors.category}</p>}
                                </div>

                                <div className="flex flex-col gap-1">
                                    <input 
                                        className='placeholder:text-[#B0B0B0] text-[14px] leading-[26px] outline-none py-3 px-[11px] w-full h-fit bg-[#232327] rounded-[9px] border border-[#1F1F1F] text-[#FFFFFF]'
                                        type="text" 
                                        placeholder='Website (if applicable)' 
                                        name='websiteLink' 
                                        id='websiteLink' 
                                        value={formInputs.websiteLink} 
                                        onChange={changeHandler} 
                                    />

                                    {formErrors.websiteLink && <p className='ml-1 text-[12px] leading-5 text-[#DC2626]'>{formErrors.websiteLink}</p>}
                                </div>

                                <div className="flex flex-col gap-1">
                                    <div onClick={handleGstToggle} className="relative text-[14px] leading-[26px] cursor-pointer py-3 px-[11px] bg-[#232327] rounded-[9px] flex items-center gap-[10px]">
                                        <p className='w-[calc(100%-24px)] select-none text-[#B0B0B0]'>
                                            Do you have GST registration? {formInputs.isGstAvailable !== null ? (formInputs.isGstAvailable ? 'Yes' : 'No') : ''}
                                        </p>

                                        <div className="w-6 h-6 flex items-center justify-center">
                                            <img src={ChevronDownLargeDarkMode} alt="" />
                                        </div>

                                        {
                                            gstToggle && 
                                            <div className="absolute z-10 w-full top-14 text-[#B0B0B0] left-0 rounded-[9px] bg-[#232327] overflow-hidden shadow-[0px_0px_6px_0px_#FFFFFF1F]">
                                                <p onClick={handleGstOptionClick} id='Yes' className='w-full select-none cursor-pointer py-3 px-[11px] hover:bg-[#29292E]'>Yes</p>

                                                <p onClick={handleGstOptionClick} id='No' className='w-full select-none cursor-pointer py-3 px-[11px] hover:bg-[#29292E]'>No</p>
                                            </div>
                                        }
                                    </div>

                                    {formErrors.isGstAvailable && <p className='ml-1 text-[12px] leading-5 text-[#DC2626]'>{formErrors.isGstAvailable}</p>}
                                </div>

                                <div className="flex flex-col gap-1">
                                    <input 
                                        className='placeholder:text-[#B0B0B0] text-[14px] leading-[26px] outline-none py-3 px-[11px] w-full h-fit bg-[#232327] rounded-[9px] border border-[#1F1F1F] text-[#FFFFFF]'
                                        type="text" 
                                        placeholder='Any social media link' 
                                        name='socialLink' 
                                        id='socialLink' 
                                        value={formInputs.socialLink} 
                                        onChange={changeHandler} 
                                    />

                                    {formErrors.socialLink && <p className='ml-1 text-[12px] leading-5 text-[#DC2626]'>{formErrors.socialLink}</p>}
                                </div>
                            </div>

                            <div className="flex flex-col gap-1">
                                <textarea 
                                    className='placeholder:text-[#B0B0B0] text-[14px] leading-[26px] outline-none h-[120px] p-[10px] w-full bg-[#232327] rounded-lg text-[#FFFFFF] no-scrollbar' 
                                    placeholder='Tell us about your brand' 
                                    name="brandDescription" 
                                    id="brandDescription" 
                                    value={formInputs.brandDescription} 
                                    onChange={changeHandler}
                                />

                                {formErrors.brandDescription && <p className='ml-1 text-[12px] leading-5 text-[#DC2626]'>{formErrors.brandDescription}</p>}
                            </div>
                        </form>

                        <button onClick={handleFormSubmit} className='w-full font-semibold text-[18px] leading-6 text-buttonText rounded-[9px] px-3 py-4 bg-primaryColor hover:bg-primaryAccent outline-none select-none'>Submit</button>
                    </div>
                </div> : 
                <div className='max-w-screen h-screen flex items-center justify-center pb-16 overflow-y-scroll'>
                    <div className="w-[52%] h-fit flex flex-col items-center">
                        <div className="w-[200px] h-[200px] flex items-center justify-center">
                            <img className='w-full h-full' src={Success} alt="" />
                        </div>

                        <div className="flex flex-col items-center gap-2 shadow-[0px_0px_12px_0px_#FFFFFF40] px-6 py-[23px] select-none">
                            <h1 className='font-semibold text-2xl text-[#121212]'>Thank You for Choosing Xenie for Your Brand!</h1>

                            <p className='font-normal text-[16px] leading-[26px] text-[#666666] text-center'>We appreciate your interest in joining Xenie. Our team will review your inquiry, and we'll be in touch soon to discuss how we can collaborate to bring your brand to our dynamic platform. Stay tuned for exciting possibilities!</p>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default ApplySeller;
